import React from 'react';
import { Collapse, Row, Col } from 'antd';
const { Panel } = Collapse;

const Location = () => {
    function callback(key) {}

    return (
        <div className="locationContainer">
            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h1 className="locationTitle">Our Locations</h1>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Yangon</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Yangon Airport (Seasons Hotel)" key="1">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Yangon Airport (Seasons Hotel) <br />
                                <span className="locationAddress">Address:</span> Seasons Hotel, Yangon International
                                Airport, Mingalardon Township, Yangon.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="Strand Square (53, Strand Rd)" key="2">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Strand Square (53, Strand Rd)
                                <br />
                                <span className="locationAddress"> Addr</span>ess: No. 53, Strand Rd, Yangon. 11141
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="Pun Hlaing Estate (The Campus)" key="3">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Pun Hlaing Estate (The Campus)
                                <br />
                                <span className="locationAddress"> Addr</span>ess: The Campus, 1 Office Park, Rain Tree
                                Drive, Pun Hlaing Estate, Hlaing Tharyar Township, Yangon 11401
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="People`s Park" key="4">
                            <address>
                                <span className="locationHub">Rental Hub:</span> People's Park
                                <br />
                                <span className="locationAddress">Address:</span> People's Park, Myanmar Culture Valley,
                                U Wisara Road, Yangon
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="MICT Park" key="5">
                            <address>
                                <span className="locationHub">Rental Hub:</span> MICT Park
                                <br />
                                <span className="locationAddress"> Addr</span>ess: GEMS Condo , Thazin Street, Hlaing
                                Township.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="GEMS Condo (Hlaing Township)" key="6">
                            <address>
                                <span className="locationHub">Rental Hub:</span> GEMS Condo (Hlaing Township)
                                <br />
                                <span className="locationAddress">Address:</span> GEMS Condo , Thazin Street, Hlaing
                                Township.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="FMI City (Yoma Fleet Yard)" key="7">
                            <address>
                                <span className="locationHub">Rental Hub:</span> FMI City (Yoma Fleet Yard)
                                <br />
                                <span className="locationAddress"> Addr</span>ess: Shwe Mar Lar St, FMI City, Hlaing
                                Tharyar Township, Yangon 11401
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="Dhammazedi Road (Times Link)" key="8">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Dhammazedi Road (Times Link)
                                <br />
                                <span className="locationAddress"> Addr</span>ess: No.11 & 12, Golden Link Condominium,
                                Corner of Dhammazedi Road and Link Road, Eash Shwegondaing, Bahan Township, Yangon.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                        <Panel header="Capital Hypermarket (Tharkayta)" key="9">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Capital Hypermarket (Tharkayta)
                                <br />
                                <span className="locationAddress">Address:</span> 14E, Min Nandar Rd, Tharkayta
                                Township, Yangon 11231.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946680
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Southern Shan State</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Taunggyi City" key="10">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Taunggyi <br />
                                <span className="locationAddress">Address:</span> No. 442, Chan Thar Ward, West Circular
                                Road (War Pyar Lann Sone), Taunggyi Township.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946640
                            </address>
                        </Panel>
                        <Panel header="Heho Airport" key="11">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Heho Airport
                                <br />
                                <span className="locationAddress">Address:</span> Heho Airport
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946640
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Naypyitaw</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Naypyitaw Airport" key="12">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Naypyitaw Airport
                                <br />
                                <span className="locationAddress">Address:</span> Naypyitaw Airport
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-265444415
                            </address>
                        </Panel>
                        <Panel header="Capital Hypermarket (Naypyitaw)" key="13">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Capital Hypermarket (Naypyitaw)
                                <br />
                                <span className="locationAddress">Address:</span> Naypyitaw Capital Hypermarket, Yaza
                                Thingaha Road, Naypyitaw, Myanmar.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-265444415
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Myitkyina</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Myitkyina Airport" key="14">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Myitkyina Airport
                                <br />
                                <span className="locationAddress">Address:</span> Naypyitaw Airport
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-265444415
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Mandalay</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Mandalay City (Chan Mya Thar Si)" key="15">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Mandalay City (Chan Mya Thar Si)
                                <br />
                                <span className="locationAddress">Address:</span> 78 street, Beside Chan Mya Thar Si
                                Monastery, Chan Mya Thar Si Township, Mandalay.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09- 265444416
                            </address>
                        </Panel>
                        <Panel header="Mandalay Airport" key="16">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Mandalay Airport
                                <br />
                                <span className="locationAddress">Address:</span> Mandalay International Airport
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-265444416
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Northern Shan State</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Lashio Airport" key="17">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Lashio Airport
                                <br />
                                <span className="locationAddress">Address:</span> Lashio Airport.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946690
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Dawei</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Dawei Airport" key="18">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Dawei Airport
                                <br />
                                <span className="locationAddress">Address:</span> Dawei Aiport
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-428946696
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>

            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h5 className="locationSubTitle">Bagan</h5>
                    <Collapse onChange={callback}>
                        <Panel header="Bagan Airport" key="19">
                            <address>
                                <span className="locationHub">Rental Hub:</span> Bagan Airport
                                <br />
                                <span className="locationAddress">Address:</span> Aung Myay Thar 2nd st, near Airport
                                Road, Aung Myay Thar quarter. Nyaung U city.
                                <br />
                                <span className="locationPhone">Phone Number:</span> 09-265444413
                            </address>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </div>
    );
};

export default Location;
